import { __read, __awaiter, __generator } from 'tslib';
import React__default, { createContext, useState, useCallback, useEffect } from 'react';
import { getGlobalTextCopy } from '@invitae/nucleobase-engine-contentful';

var GlobalTextCopyContext = createContext({});
var GlobalTextCopyContextProvider = function (_a) {
    var children = _a.children, textCopies = _a.textCopies, enableClientSideRequest = _a.enableClientSideRequest, contentfulConfig = _a.contentfulConfig, countryCode = _a.countryCode;
    var _b = __read(useState((textCopies || {})), 2), globalTextCopies = _b[0], setGlobalTextCopies = _b[1];
    var requestGlobalTexts = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var globalTexts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!contentfulConfig)
                        return [2 /*return*/];
                    return [4 /*yield*/, getGlobalTextCopy({
                            contentfulClientCredentials: contentfulConfig,
                            countryCode: countryCode,
                            usePreviewClient: false,
                        })];
                case 1:
                    globalTexts = _a.sent();
                    setGlobalTextCopies(globalTexts);
                    return [2 /*return*/];
            }
        });
    }); }, [contentfulConfig, countryCode]);
    useEffect(function () {
        var isTextCopiesEmpty = !Object.keys(globalTextCopies).length;
        if (isTextCopiesEmpty && enableClientSideRequest) {
            requestGlobalTexts();
        }
    }, [requestGlobalTexts, enableClientSideRequest, globalTextCopies]);
    return React__default.createElement(GlobalTextCopyContext.Provider, { value: { globalTextCopies: globalTextCopies } }, children);
};

export { GlobalTextCopyContext, GlobalTextCopyContextProvider };
//# sourceMappingURL=GlobalTextCopyContext.esm.js.map
